import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CInputGroup,
  CRow,
} from '@coreui/react-pro'
import React from 'react'
import { AccessCardDetailsApi } from '../../../middleware/api/EmployeeDirectory/AccessCardDetails/accessCardDetailsApi'
import { reduxServices } from '../../../reducers/reduxServices'
import { useAppDispatch, useTypedSelector } from '../../../stateStore'
import {
  AccessCardFilterOptionsType,
  EmploymentStatus,
} from '../../../types/EmployeeDirectory/AccessCardDetails/accessCardDetailsTypes'
import { downloadFile } from '../../../utils/helper'

const AccessCardFilterOptions = ({
  searchInput,
  setSearchInput,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
}: AccessCardFilterOptionsType): JSX.Element => {
  const dispatch = useAppDispatch()

  // const countries = useTypedSelector(reduxServices.visaList.selectors.countries)
  const getAccessCardsData = useTypedSelector(
    reduxServices.accessCardDetails.selectors.getAcessCards,
  )
  const selectedEmploymentStatus = useTypedSelector(
    reduxServices.accessCardDetails.selectors.selectedEmploymentStatus,
  )

  const handleExportAccessCardData = async () => {
    const exportInternDataBlob =
      await AccessCardDetailsApi.exportAccessCardsList({
        country: 'India',
        status: selectedEmploymentStatus,
        searchStr: searchInput,
      })
    downloadFile(exportInternDataBlob, 'accessCardData.csv')
  }

  // const onChangeCountryHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setSelectCountry(e.target.value)
  //   setCurrentPage(1)
  //   setPageSize(20)
  // }

  const searchButtonHandlerOnKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'Enter') {
      if (searchInput === '') {
        dispatch(
          reduxServices.accessCardDetails.getAccessCardsList({
            startIndex: pageSize * (currentPage - 1),
            endIndex: pageSize * currentPage,
            searchStr: searchInput || '',
            country: '',
            status: selectedEmploymentStatus,
          }),
        )
        setCurrentPage(1)
        setPageSize(20)
      } else {
        dispatch(
          reduxServices.accessCardDetails.getAccessCardsList({
            startIndex: pageSize * (currentPage - 1),
            endIndex: pageSize * currentPage,
            searchStr: searchInput || '',
            country: 'India',
            status: selectedEmploymentStatus,
          }),
        )
        setCurrentPage(1)
        setPageSize(20)
      }
    }
  }
  const searchButtonHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    dispatch(
      reduxServices.accessCardDetails.getAccessCardsList({
        startIndex: 0,
        endIndex: 20,
        searchStr: searchInput || '',
        country: 'India',
        status: selectedEmploymentStatus,
      }),
    )
    setCurrentPage(1)
    setPageSize(20)
  }

  const handleEmployeeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      reduxServices.accessCardDetails.actions.changeSelectedEmploymentStatus(
        event.target.value,
      ),
    )
    setCurrentPage(1)
    setPageSize(20)
  }

  return (
    <>
      <CRow>
        <CCol
          className="mt-1"
          sm={2}
          md={1}
          lg={1}
          data-testid="activeFilterStatus"
        >
          <CFormCheck
            type="radio"
            name="employmentStatus"
            value={EmploymentStatus.active}
            id="employmentActive"
            label="Active"
            defaultChecked={
              selectedEmploymentStatus === EmploymentStatus.active
            }
            onChange={handleEmployeeStatus}
            inline
          />
        </CCol>
        <CCol
          className="mt-1"
          sm={2}
          md={1}
          lg={1}
          data-testid="inactiveFilterStatus"
        >
          <CFormCheck
            type="radio"
            name="employmentStatus"
            value={EmploymentStatus.inactive}
            id="employmentInactive"
            label="Inactive"
            defaultChecked={
              selectedEmploymentStatus === EmploymentStatus.inactive
            }
            onChange={handleEmployeeStatus}
            inline
          />
        </CCol>
        {/* <CCol sm={2} md={1} className="text-md-end">
          <CFormLabel className="col-form-label">Country:</CFormLabel>
        </CCol> */}
        {/* <CCol sm={2}>
          <CFormSelect
            aria-label="Default select example"
            size="sm"
            id="country"
            data-testid="form-select1"
            name="selectCountry"
            value={selectCountry}
            onChange={onChangeCountryHandler}
          >
            <option value={''}>Select Country</option>
            {countries?.map((country, index) => (
              <option key={index} value={country.name}>
                {country.name}
              </option>
            ))}
          </CFormSelect>
        </CCol> */}

        <CCol
          sm={12}
          className="gap-4 d-flex justify-content-end mb-3"
          data-testid="exportBtn"
        >
          {getAccessCardsData?.length > 0 && (
            <CButton
              color="primary"
              className="text-white btn-ovh"
              size="sm"
              onClick={handleExportAccessCardData}
            >
              <i className="fa fa-plus me-1"></i>
              Click to Export
            </CButton>
          )}
        </CCol>
      </CRow>
      <CRow className="gap-2 d-md-flex justify-content-md-end">
        <CCol sm={4} md={4} xl={3} lg={4}>
          <CInputGroup className="global-search me-0 justify-content-md-end">
            <CFormInput
              data-testid="searchField"
              placeholder="Search Employee"
              aria-label="Multiple Search"
              aria-describedby="button-addon2"
              id="searchInput"
              name="searchInput"
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value)
              }}
              onKeyDown={searchButtonHandlerOnKeyDown}
            />
            <CButton
              disabled={!searchInput}
              data-testid="multi-search-btn"
              className="cursor-pointer"
              type="button"
              color="primary"
              id="button-addon2"
              onClick={searchButtonHandler}
            >
              <i className="fa fa-search"></i>
            </CButton>
          </CInputGroup>
        </CCol>
      </CRow>
    </>
  )
}

export default AccessCardFilterOptions
